
export function ProductTypesIcon(props) {
  return (
    


<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" class="-mt-0.5 h-6 w-6 flex-shrink-0 text-blue-1000"><path stroke-linecap="round" stroke-linejoin="round" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path></svg>

  );
}

ProductTypesIcon.defaultProps = {
  width: "20",
  height: "20",
};


